"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _recompose = require("recompose");

var _addNewButton = require("./addNewButton");

var _addNewButton2 = _interopRequireDefault(_addNewButton);

var _orgButton = require("./orgButton");

var _orgButton2 = _interopRequireDefault(_orgButton);

var _userButton = require("./userButton");

var _userButton2 = _interopRequireDefault(_userButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhance = (0, _recompose.compose)(_reactRouter.withRouter, (0, _recompose.withProps)(function (ownProps) {
	return {
		active: ownProps.id && ownProps.id === R.path(["match", "params", "orgID"])(ownProps)
	};
}));
//import PlaceholderButton from "./placeholderButton";
exports.default = enhance(function (props) {
	return props.isAddNew ? _react2.default.createElement(_addNewButton2.default, props) : props.isOrg ? _react2.default.createElement(_orgButton2.default, props) : //props.isPlaceholder ? <PlaceholderButton { ...props } /> :
	props.isUser ? _react2.default.createElement(_userButton2.default, props) : null;
});

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/button/index.js
// module id = 377
// module chunks = 0